import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import Loader from '../../shared/loader';

class CountryField extends Component {
    constructor(props) {
        super(props);

        this.handleCountryChange = this.handleCountryChange.bind(this);
    }

    handleCountryChange(event) {
        this.props.handleCountryChange(event.currentTarget.value);
        // Trigger the redux-form onChange callback.
        this.props.input.onChange(event.currentTarget.value);
        this.props.input.onBlur();
    }

    render() {
        const { meta: { touched, error } } = this.props;
        let errorClassName = '';
        if (touched && error) {
            errorClassName = 'has-error ';
        }

        const countryOptionsMarkup = this.props.countries.map((country, idx) => (
            <option key={idx} value={country.iso}>
                {country.name}
            </option>
        ));

        return (
            <div style={{ position: 'relative' }} className={`${errorClassName}`}>
                <select name={`${this.props.fieldNamePrefix}[country_iso]`} onChange={this.handleCountryChange} className="form-control primary-input-field" value={this.props.selectedCountryIso}>
                    <option value="" disabled>{this.props.intl.formatMessage({ id: 'select', defaultMessage: 'Select' })}</option>
                    {countryOptionsMarkup}
                </select>
                {this.props.countries.length === 0 && (
                    <div style={{
                        position: 'absolute', top: '5px', right: '4px', backgroundColor: '#fff',
                    }}
                    >
                        <Loader displayLoader size={25} />
                    </div>
                )}
                {touched && error && <span className="help-block">{error}</span>}
            </div>
        );
    }
}

export default injectIntl(CountryField);



/** WEBPACK FOOTER **
 ** ./src/components/checkout-steps/address/country-field.jsx
 **/